import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiOnboardingReportWidgetBaseDirective } from '../fi-onboarding-widget-base.directive';

@Component({
    selector: 'fi-common-onboardings-widget',
    templateUrl: './common-onboardings-widget.component.html',
    styleUrls: ['./common-onboardings-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-common-onboardings-widget' },
    standalone: false,
})
export class FiCommonOnboardingsWidgetComponent extends FiOnboardingReportWidgetBaseDirective {}
